import { useQuery } from '@tanstack/react-query'
import { ExternalLink } from 'lucide-react'
import { api, type Publish } from '../lib/api'
import { Empty, PageHeader, Spinner, StatusChip, ago } from '../components/ui'

export default function PublishHistory() {
  const list = useQuery({
    queryKey: ['publish', 'list'],
    queryFn: () => api.get<{ items: Publish[] }>('/publish').then((r) => r.items),
    refetchInterval: (q) => (q.state.data?.some((p) => p.status === 'queued' || p.status === 'building') ? 5000 : false),
  })
  return (
    <>
      <PageHeader title="Publish history" />
      {list.isPending && <Spinner />}
      {list.data?.length === 0 && <Empty>Nothing published from the CMS yet.</Empty>}
      <ul className="card divide-y divide-line">
        {list.data?.map((p) => (
          <li key={p.id} className="flex flex-wrap items-center gap-3 px-4 py-3 text-sm">
            <StatusChip status={p.status} />
            <span className="text-muted">{new Date(p.createdAt).toLocaleString('en-GB')} ({ago(p.createdAt)})</span>
            <span className="text-faint">{p.triggeredBy ?? 'someone'}</span>
            {p.runUrl && (
              <a className="ms-auto inline-flex items-center gap-1 text-accent" href={p.runUrl} target="_blank" rel="noreferrer">
                build log <ExternalLink className="h-3 w-3" />
              </a>
            )}
            {p.message && <p className="w-full whitespace-pre-line text-xs text-danger">{p.message}</p>}
          </li>
        ))}
      </ul>
    </>
  )
}
